import { FC } from 'react';
import Typography from '@ixigo/iui/Typography';
import { BotSession } from '../timelineTypes';
import { formatDateTime } from '../../../utils/dateFormatter';
import ContentSection from '../ContentSection';
import BaseDetailsModal from './BaseDetailsModal';

interface BotSessionDetailsProps {
    session: BotSession | null;
    isOpen: boolean;
    onClose: () => void;
}

const BotSessionDetails: FC<BotSessionDetailsProps> = ({ session, isOpen, onClose }) => {
    if (!session) return null;

    const { date: createdDate, time: createdTime } = formatDateTime(session.createdAt);

    return (
        <BaseDetailsModal
            isOpen={isOpen}
            onClose={onClose}
            title={session.dialogueFlowName}
            subtitle={`Started: ${createdDate} | ${createdTime}`}
        >
            <ContentSection title='Session Description'>
                <Typography variant='body-md' className='text-charcoal-800 leading-relaxed'>
                    {session.description}
                </Typography>
            </ContentSection>
        </BaseDetailsModal>
    );
};

export default BotSessionDetails;
